import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

//自定义语言包的导入
import en from '../../src/assets/i18n/en.js'
import zh from '../../src/assets/i18n/zh.js'


//element ui的语言引入
import locale from 'element-ui/lib/locale'
import enLocale from '../../node_modules/element-ui/lib/locale/lang/en.js'
import zhLocale from '../../node_modules/element-ui/lib/locale/lang/zh-CN'

// 以下为语言包单独设置的场景，单独设置时语言包需单独引入
const messages = {
    'zh_CN': Object.assign(zh, zhLocale),   // 中文语言包
  	'en_US': Object.assign(en, enLocale)    // 英文语言包
}

// 最后 export default，这一步肯定要写的。
export default new VueI18n({
  locale : 'zh_CN', // set locale 默认显示中文
  messages : messages // set locale messages
})


//////////////////
// WEBPACK FOOTER
// ./static/js/i18n.js
// module id = null
// module chunks = 